import React, { Fragment, useState } from 'react'
import {  formatDbDateWithoutTime } from '../../utils/dateFormater';
import { formatWhatsAppNumber } from '../../utils/whatsappLinkFormater';
import SingleOrderButtons from './SingleOrderButtons';

const SingleReservation = ({ order, user }) => {




    const [copied, setCopied] = useState(false);




    const handleCopy = async (value) => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);

            setTimeout(() => {
                setCopied(false);
            }, 1500);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    };










    const handleClassName = (orderStatus) => {


        if (orderStatus === "ORDERED") return "text-green-600 bg-green-100";
        if (orderStatus === "REVIEWED") return "text-pink-500 bg-pink-100";
        if (orderStatus === "DELIVERED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "SUSPENDED") return "text-orange-500 bg-orange-100";
        if (orderStatus === "ON_HOLD") return "text-blue-500 bg-blue-100";
        if (orderStatus === "REFUNDED") return "text-green-600 bg-green-100";
        if (orderStatus === "COMMISSIONED") return "text-slate-500 bg-slate-100";
        if (orderStatus === "COMPLETED") return "text-purple-500 bg-purple-100";
        if (orderStatus === "CANCELLED") return "text-[#B04926] bg-[#b0482637]";
        if (orderStatus === "REVIEW_DELETED") return "text-red-500 bg-red-100";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-red-500 bg-red-100";

    }











    return (
        <Fragment>
            <div className={`flex py-[1.2vmax] border border-zinc-100 border-l-4 border-l-indigo-600 w-[250%] lg:w-full bg-white mb-[1vmax] rounded-r-xl rounded-l-md hover:shadow-md transition-all items-center`}>
                <div className="text-center flex-center items-center flex-[1] min-w-[100px] text-zinc-700 font-bold text-[1.5vmax] lg:text-[0.8vmax] font-jakarta" >
                    #{order?.id}
                </div>
                <div className="px-[0.5vmax] flex-[1] min-w-[120px] text-zinc-700 text-[1.5vmax] lg:text-[0.8vmax] flex gap-[0.5vmax] items-center font-jakarta" >
                    <div className="flex items-center gap-1">
                        <span className="text-zinc-600 font-medium" >
                            {order?.product_id}
                        </span>
                        <button
                            onClick={() => handleCopy(order?.product_id)}
                            className="text-zinc-400 hover:text-zinc-600 transition-colors text-sm"
                            title={copied ? "Copied" : "Copy"}
                        >
                            <i
                                className={`fa-regular ${copied ? "fa-circle-check text-emerald-500" : "fa-copy"
                                    }`}
                            ></i>
                        </button>
                    </div>
                </div>
                
                <div className="flex-center px-[0.5vmax] flex-[1] min-w-[120px] text-zinc-700 text-[1.5vmax] lg:text-[0.8vmax] font-jakarta" >
                    <a href={formatWhatsAppNumber(order?.pm_country_code, order?.pm_phone_number)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center hover:text-indigo-600 transition-colors">
                        <i className="fa-brands fa-whatsapp text-emerald-500 text-[2.5vmax] lg:text-[1.5vmax]"></i>
                        <span className="font-bold text-zinc-800 text-[1.3vmax] lg:text-[0.8vmax] mt-1">{order?.pm_name}</span>
                    </a>
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1] min-w-[120px] text-zinc-700 font-semibold text-[1.5vmax] lg:text-[0.8vmax] font-jakarta" >
                    {order?.pm_commission_amount ? `Rs. ${order?.pm_commission_amount}` : "Rs. 0.00"}
                </div>

                <div className="text-center flex-center px-[0.5vmax] flex-[1.5] min-w-[150px] text-zinc-500 text-[1.5vmax] lg:text-[0.8vmax] font-jakarta" >
                    {formatDbDateWithoutTime(order?.updated_at)}
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1.5] min-w-[130px]" >
                    <span className={`text-[1.2vmax] lg:text-[0.75vmax] font-jakarta font-semibold uppercase px-3 py-1 rounded-full ${handleClassName(order?.status)}`}
                    >
                        {order?.status === "ON_HOLD" ? "ON HOLD" : order?.status === "REVIEW_DELETED" ? "REVIEW DELETED " : order?.status === "SYSTEM_CANCELLED" ? "SYSTEM CANCEL" : order?.status}
                    </span>
                </div>

                <div className="flex-center px-[0.5vmax] flex-[1] min-w-[100px] " >
                    <SingleOrderButtons order={order} user={user} />
                </div>
            </div>
        </Fragment>
    )
}

export default SingleReservation